import { createApp } from 'vue';
import SingleLineAddressWrapper from '../../components/SingleLineAddressWrapper.vue';
import '@smartdesign/core/css/main.css';
import './ValuationRangeSingleLineAddress.scss';

class ValuationRangeSingleLineAddress extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(this.resizeHandler.bind(this));
    this.track = this.track.bind(this);
  }

  static get observedAttributes() {
    return ['layout', 'target', 'breakpoint', 'banner-type', 'logo', 'platform', 'floating-button', 'no-floating-button', 'm-tracking'];
  }

  computeBreakpointLayout() {
    const breakpoint = Number(this.getAttribute('breakpoint')) || 768;

    return this.offsetWidth < breakpoint ? 'vertical' : 'horizontal';
  }

  resizeHandler() {
    this.propUpdaters?.layout(this.computeBreakpointLayout());
  }

  connectedCallback() {
    this.attachShadow({ mode: 'open' });
    const rootComponent = SingleLineAddressWrapper;
    this.vueApp = createApp(rootComponent, {
      initialProps: this.getAttributes(),
      setPropUpdaters: propUpdaters => {
        this.propUpdaters = propUpdaters;

        this.sendProps();

        if (!this.getAttribute('layout')) {
          this.resizeObserver.observe(this);
        }
      },
    });
    this.vueApp.config.globalProperties.track = this.track;
    this.vueApp.mount(this.shadowRoot);
  }

  track(eventName) {
    if (this.getAttribute(`on-${eventName}`)) {
      // eslint-disable-next-line no-eval
      eval(this.getAttribute(`on-${eventName}`));
    }

    const event = new Event(eventName, {
      bubbles: true,
    });

    this.dispatchEvent(event);
  }

  sendProps() {
    for (const [attrName, value] of Object.entries(this.getAttributes())) {
      this.propUpdaters[attrName](value);
    }
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'layout') {
      if (!newValue && oldValue) {
        this.resizeObserver.observe(this);
      } else if (newValue && !oldValue) {
        this.resizeObserver.unobserve(this);
     }
    }

    if (!this.propUpdaters) {
      return;
    }

    this.sendProps();
  }

  getAttributes() {
    return {
      layout: this.getAttribute('layout') || this.computeBreakpointLayout() || undefined,
      target: this.getAttribute('target') ?? '_blank',
      type: this.getAttribute('banner-type') || undefined,
      logo: this.getAttribute('logo') !== null,
      platform: this.getAttribute('platform') || 'immowelt',
      floatingButton: this.getAttribute('floating-button') || undefined,
      noFloatingButton: this.getAttribute('no-floating-button') !== null,
      mTracking: this.getAttribute('m-tracking') || undefined,
    };
  }
}

customElements.define('valuation-range-single-line-address', ValuationRangeSingleLineAddress);
